import styles from "./CourseOverflow.module.css";

const Logo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      viewBox="0 0 300 300"
      className={styles.logo}
    >
      <path
        fill="none"
        stroke="#000"
        strokeWidth="6"
        d="M82.846 240.925l18.887-56.944L138.396 150l-9.999 50.59 18.887 40.335"
        transform="matrix(1.04409 0 0 .84369 28.123 93.974)"
      ></path>
      <path
        fill="none"
        stroke="#000"
        strokeWidth="6"
        d="M116.266 196.477l20.352-81.15-36.42 40.343-44.988-18.219"
        transform="matrix(.99606 -.01308 .01247 .94974 54.247 35.28)"
      ></path>
      <path
        fill="none"
        stroke="#000"
        strokeWidth="6"
        d="M187.914 140.823l-38.338 27.72-35.519-26.256"
      ></path>
      <ellipse
        strokeWidth="0"
        rx="23.878"
        ry="28.157"
        transform="matrix(.82833 .34472 -.3563 .85615 196.872 117.662)"
      ></ellipse>
      <rect
        width="48.093"
        height="15.245"
        strokeWidth="0"
        rx="0"
        ry="0"
        transform="matrix(1.6906 .47231 -.42134 1.50815 62.401 123.53)"
      ></rect>
      <rect
        width="48.093"
        height="15.245"
        strokeWidth="0"
        rx="0"
        ry="0"
        transform="matrix(1.5988 .72459 -.64639 1.42626 69.864 81.413)"
      ></rect>
      <rect
        width="48.093"
        height="15.245"
        strokeWidth="0"
        rx="0"
        ry="0"
        transform="matrix(1.39986 1.05904 -.94475 1.2488 103.363 48.916)"
      ></rect>
      <rect
        width="48.093"
        height="15.245"
        strokeWidth="0"
        rx="0"
        ry="0"
        transform="matrix(1.10385 1.3648 -1.21751 .98473 128.813 7.891)"
      ></rect>
      <rect
        width="48.093"
        height="15.245"
        strokeWidth="0"
        rx="0"
        ry="0"
        transform="matrix(.7545 1.5849 -1.41386 .67308 177.837 2.76)"
      ></rect>
    </svg>
  );
};

export default Logo;
